<template>
    <Layout>
        <b-row>
            <b-col xl="2" sm="3">
                <Menu @back="handleBack"/>
            </b-col>
            <b-col xl="10" sm="9">
                <b-row>
                    <b-col xl="8" sm="12">
                        <b-card no-body>
                            <template #header>
                                <div class="d-flex">
                                    <b-button @click="$router.back()" size="sm" variant="outline-secondary" class="me-2">
                                        <i class="fas fa-arrow-left"></i>
                                    </b-button>
                                    <strong class="pt-1">
                                        Basic Details
                                    </strong>
                                </div>
                            </template>
                            <!--<b-form v-if="client_profile != null">
                                <b-row>
                                    <b-col class="mb-1" xl="3" md="6" sm="12">
                                        <label class="w-100 mb-0" for="">Name:</label>
                                        {{client_profile.name}}
                                    </b-col>
                                    <b-col class="mb-1" xl="3" md="6" sm="12">
                                        <label class="w-100 mb-0" for="">Email:</label>
                                        {{client_profile.email}}
                                    </b-col>
                                    <b-col class="mb-1" xl="3" md="6" sm="12">
                                        <label class="w-100 mb-0" for="">Cellphone No:</label>
                                        {{client_profile.cell_no}}
                                    </b-col>
                                    <b-col class="mb-1" xl="3" md="6" sm="12">
                                        <label class="w-100 mb-0" for="">Assigned Level</label>
                                        {{client_profile.user_level.name}}
                                    </b-col>
                                </b-row>
                            </b-form> -->
                            <b-form class="p-2 usersForm" v-if="client_profile">
                                <b-row>
                                    <b-col xl="8" xs="12">
                                        <b-row>
                                            <b-col cols="6">
                                                <b-form-group id="name" label="Name" label-for="name-input">
                                                    <b-form-input size="sm" id="name-input" v-model="form.name" type="text" placeholder="Enter name" required></b-form-input>
                                                </b-form-group>
                                            </b-col>

                                            <b-col cols="6">
                                                <b-form-group id="email" label="Email" label-for="email-input">
                                                    <b-form-input size="sm" id="email-input" v-model="form.email" type="email" placeholder="Enter email" required></b-form-input>
                                                </b-form-group>
                                            </b-col>

                                        </b-row>
                                        <!-- --------------------- -->
                                        <b-row>
                                            <b-col xl="4" >
                                                <b-form-group id="cell_no" label="Cell No" label-for="number-input">
                                                    <b-form-input size="sm" id="number-input" v-model="form.cell_no" type="number" placeholder="Enter cell number" required></b-form-input>
                                                </b-form-group>
                                            </b-col>

                                            <b-col cols="4">
                                                <b-form-group id="id_number" label="ID Number" label-for="id-input">
                                                    <b-form-input size="sm" id="id-input" v-model="form.id_number" type="number" placeholder="ID number" required></b-form-input>
                                                </b-form-group>
                                            </b-col>

                                            <b-col cols="4">
                                                <b-form-group id="years_experience" label="Years Experience" label-for="years_experience-input">
                                                    <b-form-input size="sm" id="years_experience-input" v-model="form.years_experience" type="number" placeholder="Enter years of experience" required></b-form-input>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </b-col>

                                    <!-- //! temp removed display of profile pic section -->
                                    <!-- <b-col order-sm="1" order-xs="2"  xl="4" xs="12">
                                        <b-form-group id="years_experience" class="p-0 m-0" label="Profile Picture" label-for="profile-pic">
                                            <b-card body-class="p-1 m-1"  class="border border-light  mb-0">
                                                <img src="@/assets/user.png" width="75" height="75"/>
                                            </b-card>
                                        </b-form-group>
                                    </b-col> -->
                                </b-row>

                                <hr>

                                <b-row>
                                    <b-col>
                                        <div class="border border-grey border-radius-2 pt-2" style="cursor: pointer;">
                                            <h4 @click="is_password_expanded = !is_password_expanded" class="ps-1 d-flex card-title">
                                                Update Password
                                                <i class="ms-auto me-3" :class="iconClass(is_password_expanded)"></i>
                                            </h4>
                                        </div>
                                        <b-collapse v-model="is_password_expanded" class="p-2 bordered-collapse-container" style="" role="tabpanel">
                                            <b-row>
                                                <b-col cols="6">
                                                    <b-form-group label="New Password" >
                                                        <b-form-input autocomplete="off" size="sm" :id="getRandomId()" v-model="password_inputs.new_password" type="password" placeholder="Enter new password" required></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="6">
                                                    <b-form-group label="Confirm Password" >
                                                        <b-form-input autocomplete="new-password" size="sm" :id="getRandomId()" v-model="password_inputs.confirm_new_password" type="password" placeholder="Confirm new password" required></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-collapse>
                                    </b-col>
                                </b-row>
                                <!-- --------------------- -->
                                <b-row>
                                    <b-col>
                                        <div class="border border-grey border-radius-2 pt-2" style="cursor: pointer;">
                                            <h4 @click="is_details_expanded = !is_details_expanded" class="ps-1 d-flex card-title">
                                                Additional Details
                                                <i class="ms-auto me-3" :class="iconClass(is_details_expanded)"></i>
                                            </h4>
                                        </div>
                                        <b-collapse v-model="is_details_expanded" class="p-2 bordered-collapse-container" role="tabpanel">
                                            <b-row>
                                                <b-col cols="12">
                                                    <b-form-group id="academic_qualifications" label="Academic Qualifications" label-for="academic_qualifications-input">
                                                        <b-form-textarea size="sm" id="academic_qualifications-input" v-model="form.academic_qualifications" type="phone" placeholder="Enter academic qualifications" required></b-form-textarea>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col cols="12">
                                                    <b-form-group id="designation" label="Designation" label-for="designation-input">
                                                        <b-form-textarea size="sm" id="designation-input" v-model="form.designation" type="text" placeholder="Designation description" required></b-form-textarea>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>

                                            <b-row>
                                                <b-col cols="12">
                                                    <b-form-group id="work_qualifications" label="Work Qualifications" label-for="work_qualifications-input">
                                                        <b-form-textarea size="sm" id="work_qualifications-input" v-model="form.work_qualifications" type="text" placeholder="Enter work qualifications" required></b-form-textarea>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-collapse>
                                    </b-col>
                                </b-row>
                                

                                <!-- //! Temp removed download section -->
                                <!-- <hr>
                                <b-row>
                                    <b-form-group id="documents" label="Download Documents" label-for="documents">
                                        <b-button @click="downloadDoc('all')" :disabled="hasData('all')" variant="success">Download All</b-button>&nbsp;
                                        <b-button @click="downloadDoc('id_copy')" :disabled="hasData('id_copy_s3_src')" variant="primary">ID Copy {{form.id_copy_s3_src}}</b-button>&nbsp;
                                        <b-button @click="downloadDoc('police_clearance')" :disabled="hasData('police_clearance_s3_src')" variant="primary">Police Clearance</b-button>&nbsp;
                                        <b-button @click="downloadDoc('letter_of_appointment')" :disabled="hasData('letter_of_appointment_s3_src')" variant="primary">Letter of Appointment</b-button>&nbsp;
                                        <b-button @click="downloadDoc('letter_of_acceptance')" :disabled="hasData('letter_of_acceptance_s3_src')" variant="primary">Letter of Acceptance</b-button>&nbsp;
                                        <b-button @click="downloadDoc('job_description')" :disabled="hasData('job_desc_s3_src')" variant="primary">Job Description</b-button>&nbsp;
                                    </b-form-group>
                                </b-row> -->
                            </b-form>
                        </b-card>
                    </b-col>
                    <b-col xl="4" sm="12">
                        <b-overlay :show="is_loading_signatures">   
                            <b-card title="Documents">
                                <b-row>
                                    <b-col>
                                        <div @mouseover="hover_element = 'signature'" @mouseleave="hover_element = null" style="text-align: center;">
                                            <span ><!-- v-show="hover_element == 'signature'" -->
                                                <b-button @click="showSigningPadModal('signature')" size="sm" class="signatureButton">
                                                <i class="fas fa-pen me-1"/>
                                                Edit
                                            </b-button>
                                            </span>
                                            <h6>Signature</h6>
                                            <svg v-if="client_signature != null" id="hiddenSVG" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 300 300" width="150" height="150" style="border: 1px solid black;">
                                                <path v-for="(path, idx) of user_signature" :key="idx"
                                                :d="path" stroke-width="1.5" stroke="black" fill="none" stroke-linecap="round"></path>                        
                                            </svg>
                                            <div v-else style="width: 150px; height: 150px;">

                                            </div>
                                        </div>
                                        
                                    </b-col>
                                    <b-col v-if="client_initial != null" xl="6" sm="12">
                                        <div @mouseover="hover_element = 'initial'" @mouseleave="hover_element = null" style="text-align: center;">
                                            <span ><!-- v-show="hover_element == 'initial'" -->
                                                <b-button @click="showSigningPadModal('initial')" size="sm" class="signatureButton">
                                                <i class="fas fa-pen me-1"/>
                                                Edit
                                            </b-button>
                                            </span>
                                            <h6>Initials</h6>
                                            <svg id="hiddenSVG" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 300 300" width="150" height="150" style="border: 1px solid black;">                                                    <path v-for="(path, idx) of user_initials" :key="idx"
                                                    :d="path" stroke-width="1.5" stroke="black" fill="none" stroke-linecap="round"></path>                        
                                            </svg>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-overlay>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <!-- modals -->
        <SignatureModal ref="signatureModal" v-if="show_signature_modal"/>
    </Layout>
</template>

<script>
import { generateRandomID } from '@/helpers/genericHelpers.js'
import SignatureModal from '@/components/widgets/misc/signingModal.vue'
import Layout from '../layouts/main-stripped';
import Menu from '@/components/widgets/green-menu.vue'
import {layoutMethods} from '@/state/helpers';
import { ccbAdminState, ccbAdminMethods, userMethods, userState } from "@/state/helpers"
import _ from 'lodash'
export default {
    data:() => ({
        is_loading_signatures: true,
        show_signature_modal: false,
        hover_element: null,
        form: {},
        password_inputs:{
            new_password: '',
            confirm_new_password: '',
        },
        is_details_expanded: false,
        is_password_expanded: false,
    }),
    computed:{
        ...ccbAdminState,
        ...userState,
        user_signature(){
            let svg = this.client_signature.signature_svg;
            return svg != '' ? JSON.parse(svg) : '';
            
        },
        user_initials(){
            let svg = this.client_initial.signature_svg;
            return svg != '' ? JSON.parse(svg) : '';
        }
    },
    components:{
        Layout,
        Menu,
        SignatureModal,
    },
    methods:{
        ...ccbAdminMethods,
        ...layoutMethods,
        ...userMethods,
        getRandomId(){
            return generateRandomID();
        },
        iconClass(collapsed_state) {
            return collapsed_state ? 'fa fa-minus' : 'fa fa-plus';
        },
        showSigningPadModal(type = null){
            this.show_signature_modal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('signatureModal');
                if(type != null){
                    this.$refs.signatureModal.changeMode(type);
                }
                this.$root.$once('bv::modal::hidden',(event)=>{
                    if(event.type == 'hidden' && event.componentId == 'signatureModal'){
                        this.show_signature_modal = false;
                    }
                })
            })
        },
        handleBack(){

        },
        hasData(type){
            let disabled = true;
            if(type === 'all'){
                if(
                    this.form.id_copy_s3_src != null &&
                    this.form.job_desc_s3_src != null &&
                    this.form.police_clearance_s3_src != null &&
                    this.form.letter_of_acceptance_s3_src != null &&
                    this.form.letter_of_appointment_s3_src!= null
                ){
                    disabled = false;
                }
            }
            else if(this.form[type] != null){
                disabled = false;
            }

            return disabled;

        }
    },
    mounted(){
        
        this.$eventHub.$on('navigateBack', this.handleBackEvent)
        this.updateMenuType({
            type: 'profile',
            showMenu: true,
            showRoutes: true,
        })
        let promises = [
            this.loadClientSignature('signature'),
            this.loadClientSignature('initial'),
            this.loadClientProfile(),
        ]
        Promise.all(promises)
        .then(()=>{
            this.form = _.cloneDeep(this.client_profile)
            this.is_loading_signatures = false;
        })
    },
    beforeDestroy(){
        this.$eventHub.$off('navigateBack');
    }
}
</script>
<style>
    .signatureButton{
        position: absolute;
        bottom: 0;

        left: 50%;
        transform: translate(-50%, 0);
        width: 150px;
        
    }
    .usersForm > .row{
        padding-bottom: 0.9rem;
    }
    .usersForm > .row > div > .row{
        padding-bottom: 0.9rem;
    }

    .bordered-collapse-container{
        border-left: 1px solid var(--bs-border-color);
        border-right: 1px solid var(--bs-border-color);
        border-bottom: 1px solid var(--bs-border-color);
    }
</style>

